import toastr from "toastr";
const post = {
    getCurrentToken: function () {
        $.ajax({
            type: "GET",
            url: "/getAjaxCurrentToken"
        }).done(function (results) {
            $('meta[name="csrf-token"]').attr("content", results);
        });
    },
    postAjaxData: function (
        url,
        paramList,
        toastCompleteString,
        callBackDone,
        callBackFail,
        callBackAlways,
        async = true
    ) {
        $.ajax({
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
            },
            type: "POST",
            url: url,
            dataType: "json",
            data: paramList,
            processData: false,
            contentType: false,
            cache: false,
            async: async
        })
            .done(function (results) {
                // CSRF
                $('meta[name="csrf-token"]').attr("content", results["csrf"]);

                if (typeof callBackDone === "function") {
                    callBackDone(results, paramList);
                }

                if (toastCompleteString !== "") {
                    toastr.options = {
                        closeButton: false,
                        debug: false,
                        newestOnTop: false,
                        progressBar: false,
                        positionClass: "toast-bottom-full-width",
                        preventDuplicates: false,
                        onclick: null,
                        showDuration: "300",
                        hideDuration: "1000",
                        timeOut: "5000",
                        extendedTimeOut: "1000",
                        showEasing: "swing",
                        hideEasing: "linear",
                        showMethod: "fadeIn",
                        hideMethod: "fadeOut"
                    };
                    toastr.success(toastCompleteString);
                }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                // 失敗したときのコールバック
                post.getCurrentToken();

                // エラーが発生。エラー内容を出力する。
                if (jqXHR.status === 500 || jqXHR.status === 404) {
                    toastr.options = {
                        closeButton: false,
                        debug: false,
                        newestOnTop: false,
                        progressBar: false,
                        positionClass: "toast-bottom-full-width",
                        preventDuplicates: false,
                        onclick: null,
                        showDuration: "300",
                        hideDuration: "1000",
                        timeOut: "5000",
                        extendedTimeOut: "1000",
                        showEasing: "swing",
                        hideEasing: "linear",
                        showMethod: "fadeIn",
                        hideMethod: "fadeOut"
                    };
                    const errorString = "エラーが発生しました。しばらくお待ち下さい";
                    toastr.error(errorString);
                }

                if (typeof callBackFail === "function") {
                    callBackFail(jqXHR, textStatus, errorThrown);
                }
            })
            .always(function () {
                // 成否に関わらず実行されるコールバック
                if (typeof callBackAlways === "function") {
                    callBackAlways();
                }
            });
    }
};

window.post = post;
